import React from 'react';
import './styles/DesignerStyles.css';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

import DesignerButton from './DesignerButton';
import DesignerTextField from './DesignerTextField';

import { androidBackButton } from './Utils';

class Verification extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    // eslint-disable-next-line
    const { cookies } = props;

    this.state = {
      email: '',

      textFieldArray: ['', '', '', ''],

      verified: false,

      newPassword1: '',
      newPassword2: '',
    };
  }

  componentDidMount() {
    androidBackButton(this.handleGoBackRoom);
  }

  handleGoBackRoom = () => {
    this.props.navigate(`/ForgotPassword`);
  };

  handleVerification = () => {
    //Verifies the code from the input with the code sent to the email
  };

  handleChangePassword = () => {
    // changes the password of this user to the new password values
    if (this.state.newPassword1 === this.state.newPassword2) {
      //sent a request to the server to change the password
    } else {
      // display some error thet the 2 passwords do not match
    }
  };

  handleEmailInput = (event) => {
    this.setState({ email: event.target.value });
  };

  render() {
    return (
      <div className="ForgotPasswordHome">
        <h1 className="ForgotPasswordH1">
          {this.state.verified === true ? 'New Password' : 'Verification'}
        </h1>

        <div className="arrowBackButtonDiv_CG">
          <DesignerButton
            class="arrowBackButton"
            onClick={this.handleGoBackRoom}></DesignerButton>
        </div>

        <label className="explanationText">
          We sent you a link with the code! Check your email and Spam folder.
        </label>

        {this.state.verified ? (
          <div style={{ width: '90%' }}>
            <label className="EmailLabel" style={{ top: '260px' }}>
              Enter New Password
            </label>
            <DesignerTextField
              type="password"
              style={{ position: 'absolute', top: '280px' }}
              value={this.state.newPassword1}
              onChange={(event) => {
                this.setState({ newPassword1: event.target.value });
              }}
              minlength={4}
              placeholder={'Enter New Password'}></DesignerTextField>

            <label className="EmailLabel">Confirm Password</label>
            <DesignerTextField
              type="password"
              style={{ position: 'absolute', top: '400px' }}
              value={this.state.newPassword2}
              onChange={(event) => {
                this.setState({ newPassword2: event.target.value });
              }}
              minlength={4}
              placeholder={'Confirm Password'}></DesignerTextField>
          </div>
        ) : (
          <>
            <label className="EmailLabel" style={{ top: '250px' }}>
              Verification Code
            </label>
            <div className="verificationTextFieldsHolder">
              {this.state.textFieldArray.map((element, index) => (
                <DesignerTextField
                  style={{ width: '20%' }}
                  value={this.state.textFieldArray[index]}
                  onChange={(event) => {
                    // eslint-disable-next-line
                    this.state.textFieldArray[index] = event.target.value;
                    this.forceUpdate();
                  }}></DesignerTextField>
              ))}
            </div>
          </>
        )}

        <div
          className="createButtonOuterDiv"
          style={{ position: 'absolute', bottom: '15px' }}>
          <div className="createButtonInnerDiv">
            <DesignerButton
              class="filledButton"
              disabled={
                this.state.verified === true
                  ? this.state.newPassword1 === this.state.newPassword2
                  : this.state.textFieldArray[0] === '' ||
                    this.state.textFieldArray[1] === '' ||
                    this.state.textFieldArray[2] === '' ||
                    this.state.textFieldArray[3] === ''
              }
              onClick={
                this.state.verified === true
                  ? this.handleChangePassword
                  : this.handleVerification
              }
              buttonText={
                this.state.verified === true ? 'Change Password' : 'Verify'
              }></DesignerButton>
          </div>
        </div>
      </div>
    );
  }
}

export default withCookies(Verification);
